import React from 'react'
import { Link } from 'react-router-dom';
import paths from '../../routes/paths';
import { textCodes, titleCodes } from '../../template_codes/phyohandmade/about_page_codes';



export default function About() {
    return (

        <div className="pt-20">
           
            <div className='container w-4/5 text-center'>
                <h1 className='text-xl lg:text-2xl xl:text-2xl 2xl:text-2xl font-bold'>{titleCodes.title.title}</h1>
                <p className='px-1 text-sm lg:text-lg xl:text-lg 2xl:text-lg lg:px-40 xl:px-40 pt-5 text-justify'>{textCodes.aboutus.text}</p>
            </div>
            <div className='container w-4/5 text-center pt-10 lg:pt-20 xl:pt-20 2xl:pt-20'>
                <h1 className='text-xl lg:text-2xl xl:text-2xl 2xl:text-2xl font-bold'>{titleCodes.title1.title}</h1>
                <p className='px-1 text-sm lg:text-lg xl:text-lg 2xl:text-lg lg:px-40 xl:px-40 pt-5 text-justify'>{textCodes.mission.text}</p>
            </div>
            <div className='container w-4/5 text-center pt-10 lg:pt-20 xl:pt-20 2xl:pt-20 pb-20'>
                <h1 className='text-xl lg:text-2xl xl:text-2xl 2xl:text-2xl font-bold'>{titleCodes.title2.title}</h1>
                <p className='px-1 text-sm lg:text-lg xl:text-lg 2xl:text-lg lg:px-40 xl:px-40 pt-5 text-justify'>{textCodes.vission.text}</p>
                <p className='px-1 text-sm lg:text-lg xl:text-lg 2xl:text-lg lg:px-40 xl:px-40 pt-5 text-justify'>{textCodes.vission1.text}</p>
            </div>
           

        </div>
    );
}
